<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入案例名称进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <div>
        <span style="line-height: 40px;margin-right:10px">创建时间</span>
        <el-date-picker
          v-model="times"
          clearable
          value-format="yyyy-MM-dd"
          @change="onTimeChange()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
      <div>
        <el-button
          type="primary"
          v-if="this.activeName === 'platform'"
          @click="event().toAddOrEditClick()">
          新建项目
        </el-button>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="平台案例"
        name="platform">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="uuid"
            label="案例编号"/>
          <el-table-column
            prop="priority"
            label="排序"/>
          <el-table-column
            prop="name"
            label="案例名称"/>
          <el-table-column
            prop="avatar"
            label="封面小图"
            width="161">
            <template slot-scope="scope">
              <img
                :src="imgDomain+'/'+scope.row.index_img"
                width="141px">
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toAddOrEditClick(scope.row.uuid)">
                编辑
              </el-button>
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDeleteClick(scope.row.uuid)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="用户案例"
        name="user">
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="uuid"
            label="案例编号"/>
          <el-table-column
            prop="priority"
            label="排序"/>
          <el-table-column
            prop="name"
            label="案例名称"/>
          <el-table-column
            prop="avatar"
            label="封面小图"
            width="161">
            <template slot-scope="scope">
              <img
                :src="imgDomain+'/'+scope.row.index_img"
                width="141px">
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toAddOrEditClick(scope.row.uuid)">
                编辑
              </el-button>
              <el-button
                v-if="scope.row.is_delete == '1'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="network().startExample(scope.row.uuid)">
                启用
              </el-button><el-button
                v-if="scope.row.is_delete == '0'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toStopClick(scope.row.uuid)">
                禁用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 确认删除 -->
    <el-dialog
      width="480px"
      title="提示"
      :visible.sync="deleteStyleDialog">
      <div>确认删除数据，是否继续 ?</div>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="deleteStyleDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToDeleteClick()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 禁用 -->
    <el-dialog
      width="480px"
      title="提示"
      :visible.sync="stopDialog">
      <div>确认禁用数据，是否继续 ?</div>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="stopDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToDeleteClick()">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {deleteExample, getExampleList, startExample} from '../../api/case'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
        is_user: 'no',
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      activeName: 'platform',
      deleteStyleDialog: false,
      stopDialog: false,
    };
  },

  components: {
  },
  created() {
    this.network().getExampleList()
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'platform') {
        this.body.is_user = 'no'
        this.body.is_audit = ''
      } else if (tab.name === 'user') {
        this.body.is_user = 'yes'
        this.body.is_audit = '1'
      }
      this.network().getExampleList()
    },
    handleCurrentChange () {
      this.network().getExampleList()
    },
    search() {
      this.network().getExampleList()
    },
    event() {
      return {
        clearKeyword:() => {
          this.body.keyword = ''
        },
        toAddOrEditClick: (uuid) => {
          this.$router.push({ path: 'case-add', query: { uuid } })
        },
        toStopClick: (uuid) => {
          this.stopDialog = true
          this.deleteUuid = uuid
        },
        toDeleteClick: (uuid) => {
          this.deleteStyleDialog = true
          this.deleteUuid = uuid
        },
        onSureToDeleteClick: () => {
          this.network().deleteExample()
        },
      }
    },
    network() {
      return {
        getExampleList: async () => {
          const { status, data } = await getExampleList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        deleteExample: async () => {
          const { status } = await deleteExample({'uuid': this.deleteUuid})
          if (status !== 200) return
          this.stopDialog = false
          this.deleteStyleDialog = false
          this.$notify({
            title: '删除/禁用成功',
            message: '删除/禁用成功',
            type: 'success',
          });
          this.network().getExampleList()
        },
        startExample: async (uuid) => {
          const { status } = await startExample({'uuid': uuid})
          if (status !== 200) return
          this.deleteStyleDialog = false
          this.$notify({
            title: '启用成功',
            message: '启用成功',
            type: 'success',
          });
          this.network().getExampleList()
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/case/list.vue